export const namespace = 'alerts'
